module.exports = __webpack_public_path__ + "img/divider-full.7bb9bcec.png";